import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from 'src/app/common-modules/material.module';
import { SharedModule } from 'src/app/common-modules/shared.module';
import { KYCListComponent } from './list/list.component';
import { InAPPCrudComponent } from './inAppBanner/crud/crud.component';
import { InAPPListComponent } from './inAppBanner/list/list.component';

// routing of bulk notification
const routes: Routes = [
  { path: 'kyc', component: KYCListComponent },
  { path:'inApp/list', component:InAPPListComponent }
  // { path: 'new', component: CrudComponent },
  // { path: 'edit', component: EditComponent },
  // { path: ':id', component: CrudComponent },
];
@NgModule({
  declarations: [ KYCListComponent,InAPPListComponent, InAPPCrudComponent],
  imports: [
    RouterModule.forChild(routes),
    MaterialModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    // NgSelectModule
  ],
  exports: [RouterModule],
})
export class AdministrationModule {}
